import router from "@/router";

export function isPublicRoute() {
  const path = router.currentRoute.path;
  return !['/user', '/admin', '/airbnb']
    .some(prefix => path.startsWith(prefix));
}
